import React from 'react';
import { useEffect, useState, useLayoutEffect, useRef } from 'react';
import { scroller } from 'react-scroll';
import { Flex, View } from '@instructure/ui';
import { getStore, usePlayerStore } from '../../../../stores/StoreContext';
import { randomId } from '../../../../helpers/utilities';
import Annotations from './Annotations';
import AnnotationMarkersRenderer from './AnnotationMarkersRenderer';

const AnnotationMarkersLive = () => {
  const containerRef = useRef(null);

  const [, setContainerWidth] = useState(null);
  const [scrollToPosition] = useState(0);

  useLayoutEffect(() => {
    const container = containerRef.current;

    if (!container) return;

    const resizeObserver = new ResizeObserver((entries) => {
      for (const entry of entries) {
        if (entry.target === container) {
          const dimensions = container.getBoundingClientRect();
          setContainerWidth(Math.floor(dimensions.width));
          // TODO: now run the new scroll calculations...
        }
      }
    });
    resizeObserver.observe(container);

    const preventScroll = (e) => {
      e.preventDefault();
    };

    // avoid allowing the mouse to scroll..
    container.addEventListener('wheel', preventScroll, { passive: false });

    return () => {
      resizeObserver.disconnect();
      if (container) {
        container.removeEventListener('wheel', preventScroll, {
          passive: false,
        });
      }
    };
  }, []);

  useEffect(() => {
    scroller.scrollTo(scrollToPosition, {
      containerId: 'scroll-container',
      smooth: true,
      duration: 100,
      horizontal: true,
    });
  }, [scrollToPosition]);

  const scrollToElement = () => {
    scroller.scrollTo('target-element', {
      containerId: 'scroll-container',
      smooth: true,
      duration: 100,
      horizontal: true,
    });
  };

  return <AnnotationMarkersRenderer />;
};

export default AnnotationMarkersLive;
